/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AssociateContractorVM } from '../models/AssociateContractorVM';
import type { AssociateContractorVMListResponseVM } from '../models/AssociateContractorVMListResponseVM';
import type { AssociateContractorVMResponseVM } from '../models/AssociateContractorVMResponseVM';
import type { LookupVMListResponseVM } from '../models/LookupVMListResponseVM';
import type { ServiceRequestVM } from '../models/ServiceRequestVM';
import type { ServiceRequestVMIEnumerableResponseVM } from '../models/ServiceRequestVMIEnumerableResponseVM';
import type { ServiceRequestVMResponseVM } from '../models/ServiceRequestVMResponseVM';
import type { StringResponseVM } from '../models/StringResponseVM';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ServiceRequestService {
    /**
     * @returns ServiceRequestVMIEnumerableResponseVM Success
     * @throws ApiError
     */
    public static getApiServiceRequest(): CancelablePromise<ServiceRequestVMIEnumerableResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/ServiceRequest',
        });
    }
    /**
     * @param requestBody
     * @returns ServiceRequestVMResponseVM Success
     * @throws ApiError
     */
    public static postApiServiceRequest(
        requestBody?: ServiceRequestVM,
    ): CancelablePromise<ServiceRequestVMResponseVM> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ServiceRequest',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns ServiceRequestVMResponseVM Success
     * @throws ApiError
     */
    public static putApiServiceRequest(
        requestBody?: ServiceRequestVM,
    ): CancelablePromise<ServiceRequestVMResponseVM> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/ServiceRequest',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param organizationId
     * @param pageSize
     * @param pageNumber
     * @param skipValue
     * @param fullyQualifiedFilters
     * @param fullyQualifiedSorts
     * @returns ServiceRequestVMIEnumerableResponseVM Success
     * @throws ApiError
     */
    public static getApiServiceRequestOrganizationlist(
        organizationId: number,
        pageSize?: number,
        pageNumber?: number,
        skipValue?: number,
        fullyQualifiedFilters?: string,
        fullyQualifiedSorts?: string,
    ): CancelablePromise<ServiceRequestVMIEnumerableResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/ServiceRequest/{organizationId}/organizationlist',
            path: {
                'organizationId': organizationId,
            },
            query: {
                'PageSize': pageSize,
                'PageNumber': pageNumber,
                'SkipValue': skipValue,
                'FullyQualifiedFilters': fullyQualifiedFilters,
                'FullyQualifiedSorts': fullyQualifiedSorts,
            },
        });
    }
    /**
     * @param propertyId
     * @param pageSize
     * @param pageNumber
     * @param skipValue
     * @param fullyQualifiedFilters
     * @param fullyQualifiedSorts
     * @returns ServiceRequestVMIEnumerableResponseVM Success
     * @throws ApiError
     */
    public static getApiServiceRequestPropertylist(
        propertyId: number,
        pageSize?: number,
        pageNumber?: number,
        skipValue?: number,
        fullyQualifiedFilters?: string,
        fullyQualifiedSorts?: string,
    ): CancelablePromise<ServiceRequestVMIEnumerableResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/ServiceRequest/{propertyId}/propertylist',
            path: {
                'propertyId': propertyId,
            },
            query: {
                'PageSize': pageSize,
                'PageNumber': pageNumber,
                'SkipValue': skipValue,
                'FullyQualifiedFilters': fullyQualifiedFilters,
                'FullyQualifiedSorts': fullyQualifiedSorts,
            },
        });
    }
    /**
     * @param unitId
     * @param pageSize
     * @param pageNumber
     * @param skipValue
     * @param fullyQualifiedFilters
     * @param fullyQualifiedSorts
     * @returns ServiceRequestVMIEnumerableResponseVM Success
     * @throws ApiError
     */
    public static getApiServiceRequestUnitlist(
        unitId: number,
        pageSize?: number,
        pageNumber?: number,
        skipValue?: number,
        fullyQualifiedFilters?: string,
        fullyQualifiedSorts?: string,
    ): CancelablePromise<ServiceRequestVMIEnumerableResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/ServiceRequest/{unitId}/unitlist',
            path: {
                'unitId': unitId,
            },
            query: {
                'PageSize': pageSize,
                'PageNumber': pageNumber,
                'SkipValue': skipValue,
                'FullyQualifiedFilters': fullyQualifiedFilters,
                'FullyQualifiedSorts': fullyQualifiedSorts,
            },
        });
    }
    /**
     * @param tenantId
     * @param pageSize
     * @param pageNumber
     * @param skipValue
     * @param fullyQualifiedFilters
     * @param fullyQualifiedSorts
     * @returns ServiceRequestVMIEnumerableResponseVM Success
     * @throws ApiError
     */
    public static getApiServiceRequestTenantlist(
        tenantId: number,
        pageSize?: number,
        pageNumber?: number,
        skipValue?: number,
        fullyQualifiedFilters?: string,
        fullyQualifiedSorts?: string,
    ): CancelablePromise<ServiceRequestVMIEnumerableResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/ServiceRequest/{tenantId}/tenantlist',
            path: {
                'tenantId': tenantId,
            },
            query: {
                'PageSize': pageSize,
                'PageNumber': pageNumber,
                'SkipValue': skipValue,
                'FullyQualifiedFilters': fullyQualifiedFilters,
                'FullyQualifiedSorts': fullyQualifiedSorts,
            },
        });
    }
    /**
     * @param contractorId
     * @param pageSize
     * @param pageNumber
     * @param skipValue
     * @param fullyQualifiedFilters
     * @param fullyQualifiedSorts
     * @returns ServiceRequestVMIEnumerableResponseVM Success
     * @throws ApiError
     */
    public static getApiServiceRequestContractorlist(
        contractorId: number,
        pageSize?: number,
        pageNumber?: number,
        skipValue?: number,
        fullyQualifiedFilters?: string,
        fullyQualifiedSorts?: string,
    ): CancelablePromise<ServiceRequestVMIEnumerableResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/ServiceRequest/{contractorId}/contractorlist',
            path: {
                'contractorId': contractorId,
            },
            query: {
                'PageSize': pageSize,
                'PageNumber': pageNumber,
                'SkipValue': skipValue,
                'FullyQualifiedFilters': fullyQualifiedFilters,
                'FullyQualifiedSorts': fullyQualifiedSorts,
            },
        });
    }
    /**
     * @param serviceRequestId
     * @returns ServiceRequestVMResponseVM Success
     * @throws ApiError
     */
    public static getApiServiceRequest1(
        serviceRequestId: number,
    ): CancelablePromise<ServiceRequestVMResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/ServiceRequest/{serviceRequestId}',
            path: {
                'serviceRequestId': serviceRequestId,
            },
        });
    }
    /**
     * @param serviceRequestId
     * @returns StringResponseVM Success
     * @throws ApiError
     */
    public static deleteApiServiceRequest(
        serviceRequestId: number,
    ): CancelablePromise<StringResponseVM> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/ServiceRequest/{serviceRequestId}',
            path: {
                'serviceRequestId': serviceRequestId,
            },
        });
    }
    /**
     * @param requestBody
     * @returns AssociateContractorVMResponseVM Success
     * @throws ApiError
     */
    public static postApiServiceRequestAssociate(
        requestBody?: AssociateContractorVM,
    ): CancelablePromise<AssociateContractorVMResponseVM> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/ServiceRequest/associate',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param serviceRequestId
     * @param associateContractorId
     * @returns StringResponseVM Success
     * @throws ApiError
     */
    public static deleteApiServiceRequestAssociate(
        serviceRequestId: number,
        associateContractorId: number,
    ): CancelablePromise<StringResponseVM> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/ServiceRequest/{serviceRequestId}/associate/{associateContractorId}',
            path: {
                'serviceRequestId': serviceRequestId,
                'associateContractorId': associateContractorId,
            },
        });
    }
    /**
     * @param serviceRequestId
     * @param associateContractorId
     * @returns StringResponseVM Success
     * @throws ApiError
     */
    public static putApiServiceRequestSchedulefix(
        serviceRequestId: number,
        associateContractorId: number,
    ): CancelablePromise<StringResponseVM> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/ServiceRequest/{serviceRequestId}/schedulefix/{associateContractorId}',
            path: {
                'serviceRequestId': serviceRequestId,
                'associateContractorId': associateContractorId,
            },
        });
    }
    /**
     * @param serviceRequestId
     * @param associateContractorId
     * @returns StringResponseVM Success
     * @throws ApiError
     */
    public static deleteApiServiceRequestSchedulefix(
        serviceRequestId: number,
        associateContractorId: number,
    ): CancelablePromise<StringResponseVM> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/ServiceRequest/{serviceRequestId}/schedulefix/{associateContractorId}',
            path: {
                'serviceRequestId': serviceRequestId,
                'associateContractorId': associateContractorId,
            },
        });
    }
    /**
     * @param serviceRequestId
     * @returns LookupVMListResponseVM Success
     * @throws ApiError
     */
    public static getApiServiceRequestAssociatedContractorsLookup(
        serviceRequestId: number,
    ): CancelablePromise<LookupVMListResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/ServiceRequest/{serviceRequestId}/associatedContractorsLookup',
            path: {
                'serviceRequestId': serviceRequestId,
            },
        });
    }
    /**
     * @param serviceRequestId
     * @returns AssociateContractorVMListResponseVM Success
     * @throws ApiError
     */
    public static getApiServiceRequestAssociatedContractors(
        serviceRequestId: number,
    ): CancelablePromise<AssociateContractorVMListResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/ServiceRequest/{serviceRequestId}/associatedContractors',
            path: {
                'serviceRequestId': serviceRequestId,
            },
        });
    }
    /**
     * @param serviceRequestId
     * @returns StringResponseVM Success
     * @throws ApiError
     */
    public static putApiServiceRequestVerify(
        serviceRequestId: number,
    ): CancelablePromise<StringResponseVM> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/ServiceRequest/{serviceRequestId}/verify',
            path: {
                'serviceRequestId': serviceRequestId,
            },
        });
    }
    /**
     * @param serviceRequestId
     * @returns StringResponseVM Success
     * @throws ApiError
     */
    public static putApiServiceRequestUnverify(
        serviceRequestId: number,
    ): CancelablePromise<StringResponseVM> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/ServiceRequest/{serviceRequestId}/unverify',
            path: {
                'serviceRequestId': serviceRequestId,
            },
        });
    }
}
